import React from 'react';
import PropTypes from 'prop-types';
import webvtt from 'node-webvtt';

import './styles.css';

const timeToolipToSeconds = (time) => {
  if (!time) return;
  const [s, m, h] = time.split(':').reverse();
  return parseInt(s) + parseInt(m) * 60 + (h ? parseInt(h) * 60 * 60 : 0);
};

const findCueFromVtt = (time, cueList) => {
  if (cueList && !isNaN(time)) {
    for (let i = 0; i < cueList.length; i++) {
      if (cueList[i].start <= time && cueList[i].end > time) {
        const [sprite, position] = cueList[i].text.split('#');
        const [x, y, width, height] = position.substring(5).split(',');
        return { sprite, x, y, width, height };
      }
    }
  }
  return null;
};

class Thumbnail extends React.Component {
  state = {};
  static getDerivedStateFromProps(props) {
    return {
      vtt: webvtt.parse(props.vtt),
    };
  }

  componentDidMount() {
    this.observeTimeValue();
  }

  observeTimeValue = () => {
    if (this.observer) {
      return;
    }

    this.observer = new window.MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        this.setState({
          time: timeToolipToSeconds(mutation.addedNodes[0].data),
        });
      });
    });

    const observerConfig = {
      childList: true,
    };

    this.observer.observe(this.props.timeToolipEl, observerConfig);
  };

  render() {
    const cue = findCueFromVtt(this.state.time, this.state.vtt.cues);

    const thumbnailStyle = cue
      ? {
          width: cue.width + 'px',
          height: cue.height + 'px',
          left: '-' + cue.width / 2 + 'px',
          bottom: 'calc(' + cue.height + 'px + 1em)',
          background:
            'url(' +
            new URL('sprite_double.png', this.props.vttSrc).toString() +
            ') -' +
            cue.x +
            'px -' +
            cue.y +
            'px',
        }
      : {};

    return <div className="videoThumbnail" style={thumbnailStyle} />;
  }
}

Thumbnail.propTypes = {
  timeToolipEl: PropTypes.any,
  vtt: PropTypes.any,
  vttSrc: PropTypes.any,
};

export default Thumbnail;
